/**
 * @file: 层板cube render 方法
 * @author: xiaolong.huang@dmall.com
 */

import * as UIToolkit from '../../UIToolkit/index';
import * as LayerRenderCore from './renderCore';
import { Watcher } from '../../observe/index';

export default function render(cube: CubeNode): void {
    UIToolkit.updateFreeLayerInShelfSize(cube.id);
    // UIToolkit.updateGoodsLayout(cube);
    // UIToolkit.updateLayerHeight(cube);

    // 渲染层板位置、大小
    new Watcher(() => {
        LayerRenderCore.renderLayerPosition(cube);
    });

    // 渲染层板放置区域
    new Watcher(() => {
        LayerRenderCore.renderDropArea(cube);
    });

    // 渲染围栏
    new Watcher(() => {
        LayerRenderCore.renderGrating(cube);
    });

    // 渲染警告信息
    new Watcher(() => {
        UIToolkit.layerWarning(cube);
    });

    // 渲染层板文字模式
    new Watcher(() => {
        LayerRenderCore.renderLayerTxtModel(cube);
    });

    // 渲染标签
    new Watcher(() => {
        LayerRenderCore.renderLayerTag(cube);
    });

    // 渲染斜度
    new Watcher(() => {
        LayerRenderCore.renderSlop(cube);
    });

    // 层板渲染状态切换
    LayerRenderCore.statusSwitch(cube);

    // 设置流动边框动画属性
    UIToolkit.setFlowBorderPropertiy(cube, '.partition-layer-bone');
}
